import { setLayersLoading_actionType } from "../constants";

export const setLayersLoading = (payload) => ({
  type: setLayersLoading_actionType,
  payload,
});
